export function checkAndRemoveEmptyArrays(filterData) {
    return filterData
        ? Object.fromEntries(Object.entries(filterData).filter(([key, value]) => {
            if (Array.isArray(value) && value.length === 0) {
                console.warn('Account filter data has an empty array for ' + key + ' this should not happen');
                return false;
            }
            else {
                return true;
            }
        }))
        : {};
}
